import React, { Component } from 'react';
import Header from '../config/Header'
import firebase from 'firebase';
import HomeEspera from './homeEspera';
import MapaEspera from './MapaEspera'

class HomeEmple extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userActu: [],
            userVehi: [],
            userViaj: [],
            userRuta: []
        }
    }

    componentDidMount() {
        let empleIUID = firebase.auth().currentUser.uid;
        if (empleIUID !== undefined) {
            firebase.database().ref('Empleados/' + empleIUID).on('value', snap => {
                let userActu = snap.val();
                userActu.key = snap.key;
                if (userActu.viajeAsignado !== false) {
                    firebase.database().ref('ProgramacionDia/' + userActu.viajeAsignado).on('value', snapVi => {
                        let userViaj = snapVi.val();
                        firebase.database().ref('Vehiculos/' + userViaj.vehiculo).once('value').then(snapV => {
                            let userVehi = snapV.val();
                            firebase.database().ref('Rutas/' + userViaj.ruta).once('value').then(snapR => {
                                let userRuta = snapR.val();
                                this.setState({ userActu, userVehi, userViaj, userRuta });
                            })
                        })

                    })
                }
                else {
                    this.setState({ userActu, userVehi: { foto: userActu.foto, movil: 'Vehículo no asignado' } });
                }
            })
        }
    }

    render() {
        let { userActu, userVehi, userViaj, userRuta } = this.state;
        return (
            <div style={{ width: '100%', height: '100%' }}>
                <Header userViaj={userViaj} />
                {!userActu.espera ?
                    <HomeEspera userActu={userActu} userVehi={userVehi} />
                :
                    <MapaEspera userActu={userActu} userVehi={userVehi} userViaj={userViaj} userRuta={userRuta} />
                }
            </div>
        )
    }
}
export default HomeEmple;


// WEBPACK FOOTER //
// ./src/Components/perfilEmpleado/homeEmple.js